import { render, staticRenderFns } from "./VerifyViaTextMessageButton.vue?vue&type=template&id=05629c87&"
import script from "./VerifyViaTextMessageButton.vue?vue&type=script&lang=js&"
export * from "./VerifyViaTextMessageButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports